import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import '@angular/common/locales/global/pl';
import { AppShellComponent } from './core/shell/shell.component';
import { SharedModule } from './shared/shared.module';
import { ShellHeaderComponent } from './core/shell/header/shell-header.component';
import { AppNavigationComponent } from './core/shell/navigation/navigation.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ProfileBoxComponent } from './core/shell/profile-box/profile-box.component';
import { KeycloakSetupModule } from './config/keycloak-setup.module';
import { HttpErrorInterceptor } from './config/error.interceptor';

@NgModule({
  declarations: [AppComponent, AppShellComponent, ShellHeaderComponent, AppNavigationComponent, ProfileBoxComponent],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    NgScrollbarModule,
    KeycloakSetupModule,
    AppRoutingModule,
    SharedModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pl' },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
